/**
 * reCAPTCHA Utility Functions
 * Provides reusable reCAPTCHA functionality across the application
 */

const SITE_KEY = "6LeJuTsrAAAAAN9R9kCHU61cvgz9o1fy3biu78__";

/**
 * Check if reCAPTCHA Enterprise is loaded and available
 * @return {boolean}
 */
export function isRecaptchaAvailable() {
  return typeof grecaptcha !== "undefined" && grecaptcha.enterprise;
}

/**
 * Generate reCAPTCHA token for form submission
 * @param {string} action - The action name
 * @return {Promise<string|null>}
 */
export async function generateRecaptchaToken(action) {
  try {
    if (!isRecaptchaAvailable()) {
      console.error("reCAPTCHA Enterprise not loaded");
      return null;
    }

    const token = await grecaptcha.enterprise.execute(
      SITE_KEY,
      action ? { action } : {}
    );
    console.log("reCAPTCHA token generated successfully for action:", action);
    return token;
  } catch (error) {
    console.error("Error generating reCAPTCHA token:", error);
    return null;
  }
}

/**
 * Add reCAPTCHA token to FormData
 * @param {FormData} formData - The form data to add token to
 * @param {string} action - The action name
 * @return {Promise<boolean>} - Returns true if token was added successfully
 */
export async function addRecaptchaTokenToFormData(formData, action) {
  const token = await generateRecaptchaToken(action);
  if (token) {
    formData.append("token", token);
    return true;
  }
  return false;
}

/**
 * Validate if a form has reCAPTCHA enabled
 * @param {HTMLFormElement} form - The form element to check
 * @return {boolean}
 */
export function isFormRecaptchaEnabled(form) {
  return form.hasAttribute("data-captcha");
}

/**
 * Get the reCAPTCHA site key
 * @return {string}
 */
export function getRecaptchaSiteKey() {
  return SITE_KEY;
}
